<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
-->

<template>
  <div class="bodyinfo-page">
      <div class="title">请确认人体成分检测报告数据：</div>
      <div class="form-wrapper">
        <van-form @submit="onSubmit" scroll-to-error="true">
          <div class="form-item">
            <div class="form-item-label">身高</div>
            <div class="form-item-input">
              <van-field v-model="formData.height" name="height" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">体重</div>
            <div class="form-item-input">
              <van-field v-model="formData.weight" name="weight" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">身体质量指数（kg/㎡）</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_mass_index" name="body_mass_index" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">体脂肪（kg）</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_fat" name="body_fat" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">体脂肪（kg）的参考范围</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_fat_reference_range" name="body_fat_reference_range_min" />
              <!-- <div class="icon-mark">~</div>
              <van-field v-model="formData.body_fat_reference_range_max" name="body_fat_reference_range_max" /> -->
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">蛋白质（kg）</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_protein" name="body_protein" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">蛋白质（kg）的参考范围</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_protein_reference_range" name="body_protein_reference_range" />
              <!-- <div class="icon-mark">~</div>
              <van-field v-model="name" name="name" /> -->
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">身体总水分（L）</div>
            <div class="form-item-input">
              <van-field v-model="formData.total_body_water" name="total_body_water" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">身体总水分（L）的参考范围</div>
            <div class="form-item-input">
              <van-field v-model="formData.total_body_water_reference_range" name="total_body_water_reference_range" />
              <!-- <div class="icon-mark">~</div>
              <van-field v-model="name" name="name" /> -->
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">骨骼肌（kg）</div>
            <div class="form-item-input">
              <van-field v-model="formData.skeletal_muscle" name="skeletal_muscle" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">骨骼肌（kg）的等级</div>
            <div class="form-item-input">
              <van-field v-model="formData.skeletal_muscle_grade" @click="openPicker('skeletal_muscle_grade')" readonly name="skeletal_muscle_grade" />
              <!-- <div class="icon-mark">~</div>
              <van-field v-model="name" name="name" /> -->
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">体脂百分比（%）</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_fat_percentage" name="body_fat_percentage" />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">体脂百分比（%）的等级</div>
            <div class="form-item-input">
              <van-field v-model="formData.body_fat_percentage_grade" @click="openPicker('body_fat_percentage_grade')" readonly name="body_fat_percentage_grade" />
              <!-- <div class="icon-mark">~</div>
              <van-field v-model="name" name="name" /> -->
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">目标摄入量</div>
            <div class="form-item-input">
              <van-field v-model="formData.baseEnergy" name="baseEnergy" />
            </div>
          </div>
         

          <van-popup v-model="showPicker" position="bottom">
            <!-- 下拉选择 -->
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />

          </van-popup>


          <div class="next-btn-wrapper">
            <van-button round block color="#FBB13D" plain @click="prevStep">上一页</van-button>
            <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
          </div>
        </van-form>
      </div>
  </div>
</template>

<script>
import {skeletal_muscleList} from '../data'
import { Dialog } from 'vant';
// import {getQueryString} from '../utils/utils'
export default {
  name: 'BodyInfoForm',
  props: {
    initData: {
      type: Object,
      default: () => {}
    },
    baseInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {},
      columns:skeletal_muscleList,
      showPicker: false,
    }
  },
  created() {

  },
  mounted() {
    
    if(this.initData){
      this.formData = {...this.initData}
    }
  },
  methods: {
    onSubmit(values) {
      let query = { ...values, ...this.formData }
      console.log("onSubmit",this.baseInfo, this.baseInfo.initHeight,query.height, this.baseInfo.initWeight,query.weight)
      if(this.baseInfo.initHeight==query.height && this.baseInfo.initWeight==query.weight){
        this.$emit('next-step',{type:'inbodyData',data:query})
      }else{
        Dialog.confirm({
          message: '当前页面身高与体重与基础信息不一致，是否继续？',
          confirmButtonText: '是',
          cancelButtonText: '否',
        })
          .then(() => {
            // on confirm
            this.$emit('next-step',{type:'inbodyData',data:query})
          })
          .catch(() => {
            // on cancel
          });
      }
     
    },
    prevStep() {
      console.log("prevStep",)
      this.$emit('prev-step')
    },
    openPicker(type){
      this.showPicker = type
    },
    onConfirm(values){
      console.log(values)
      this.formData[this.showPicker] = values.value
      this.showPicker = false
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}
.bodyinfo-page{
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}
.bodyinfo-page .title{
  height: 1.83rem;
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  margin-bottom: 1.33rem;
}
.form-wrapper{
  padding-bottom: 5rem;
}
.form-wrapper .form-item{
  margin-bottom: 2rem;
}
.form-wrapper .form-item .form-item-label{
  height: 1.83rem;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  margin-bottom: 1rem;
}
.form-wrapper .form-item .form-item-input{
 width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden; 
  background: #F8F9FA;
}
.icon-mark{
  width: 100px;
  font-size: 1.17rem;
}
.form-wrapper .form-item .form-item-input .van-cell{
  background: #F8F9FA;
}

.next-btn-wrapper{
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap:1.42rem;
  background-color: #fff;
  position:fixed;
  z-index: 99;
  bottom:0;
  left:0;
  padding:0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0,0,0,0.25);
  backdrop-filter: blur(10px);
}
</style>
